<template>
    <div :class="containerClass">
        <label :for="id" class="block font-bold">{{ label }}</label>
        <div v-if="subtitle" class="text-sm text-gray-700">
            {{ subtitle }}
        </div>
        <div class="mt-1">
            <input
                :id="id"
                :name="id"
                type="text"
                :value="modelValue"
                @input="$emit('update:modelValue', $event.target.value)"
                class="
                    shadow-sm
                    focus:ring-indigo-500 focus:border-indigo-500
                    block
                    w-full
                    sm:text-sm
                    border-gray-300
                "
                :placeholder="placeholderText"
            />
            <div v-if="error" class="mt-1 text-sm text-red-400">
                {{ error }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        "modelValue",
        "id",
        "label",
        "subtitle",
        "placeholderText",
        "containerClass",
        "error",
    ],
    emits: ["update:modelValue"],
};
</script>
